
import { defineComponent, computed, nextTick, reactive } from 'vue'
import { useI18n } from 'vue-i18n'
import { ElMessage } from 'element-plus'
import { debounce } from '@/utils/debounce'
const VModel = 'update:modelValue'
export default defineComponent({
  name: 'MessagePushModal',
  props: {
    modelValue: { // visible 是否显示
      type: Boolean,
      default: false,
    },
  },
  emits: [VModel, 'confirm'],
  setup(props, { emit }) {
    const { t, locale } = useI18n()
    const state = reactive({
      info: ''
    })

    /** 按当前语言展示对应的消息推送预览图 */
    const registeInfoImages: Record<string, string> = {
      'zh-CN': require('./_images/zh-CN/registe_info_pic.png'),
      'zh-TW': require('./_images/zh-TW/registe_info_pic.png'),
      'en-US': require('./_images/en-US/registe_info_pic.png'),
      'ja-JP': require('./_images/ja-JP/registe_info_pic.png'),
    }
    const registeInfoPic = computed(
      () => registeInfoImages[locale.value] || registeInfoImages['zh-CN']
    )

    const inputRules = debounce(() => {
      // eslint-disable-next-line no-magic-numbers
      if (state.info.length > 100) {
        ElMessage({
          message: t('groupClient.registerInfoModalMsgTooLong'),
          type: 'warning'
        })
      }
    })

    return {
      props,
      state,
      registeInfoPic,

      handleEvent(
        action: 'close' | 'confirm' | 'input'
      ) {
        switch (action) {
          case 'close':
            emit(VModel, false)
            break
          case 'confirm':
            emit(VModel, false)
            emit('confirm', state.info)
            nextTick(() => {
              state.info = ''
            })
            break
          case 'input':
            inputRules()
        }
      }
    }
  }
})
